module.exports = __webpack_public_path__ + "static/media/Kelsey Bowyer Headshot.f0c4fb44.jpeg";